module.exports = __webpack_public_path__ + "static/media/undraw_house_searching_n8mp.f4588439.svg";